import React, { useState, useCallback } from 'react'
import { commaSeparetedValue, outsideClickHandler } from '@usap/core'
import {
  Box, ResponsiveBox, Text,
} from '@usap/uicomponents'
import { CoreInfoUpdated, CorePriceBadge } from '@usap/widgets'
import { PricingBox } from './PricingInfo.css'

const displayMessage = false

export default function PricingInfo(props) {
  const {
    index,
    pricing,
    invObj,
    coreConfig,
  } = props

  const {
    regularPrice ='0.00',
    corePrice ='0.00',
  } = pricing

  
  const message = invObj && invObj.message

  const [showCorePrice, setShowCorePrice] = useState(false)

  const onCoreClick = useCallback(() => {
    outsideClickHandler(
      showCorePrice,
      [`iconClick${index}`],
      () => {
        setShowCorePrice(false)
      },
    )
    setShowCorePrice(!showCorePrice)
  }, [index, showCorePrice])
  

  const itemPrice = commaSeparetedValue(regularPrice)
  

  const hasCorePrice = corePrice && (corePrice !== '0.00' || 0)

  return (
    <ResponsiveBox id={`unitPrice${index}`} fxDirection="column">
      <PricingBox>
        <Text size="20px" weight={700} color="dark-2">

          {`$${itemPrice}`}
          {displayMessage && (
          <Text
            size="12px"
            margin={{ vertical: 10, left: 10 }}
            color="dark-2"
          >
            {message}
          </Text>
          )}
        </Text>
      </PricingBox>

      <ResponsiveBox
        style={{
          position: 'relative',
          visibility: hasCorePrice ? 'visible' : 'hidden',
          justifyContent: 'center',
          marginBottom: '12px',
          lineHeight:'16px',
        }}
      >
        {showCorePrice && <CoreInfoUpdated config={coreConfig} forPlp />}
        {corePrice && <CorePriceBadge forPlp uniqueId={index} onClick={onCoreClick} corePrice={corePrice} showCorePrice={showCorePrice} /> }
      </ResponsiveBox>
    </ResponsiveBox>

  )
}
